import { Form } from 'react-bootstrap'
import styled from 'styled-components'
import { t } from 'i18next'
import { colors } from '../../../styles/colors'
import CustomDatePicker from '../../Forms/CustomDatePicker'
import { formatedDate } from '../../../utils/formatedDate'
import InformationPopover from '../../InformationPopover/InformationPopover'
import MediaQuery from 'react-responsive'
import { StyledValidationMessage } from './formHelper'

const StyledBatchKey = styled.div`
  color: ${colors.gray3};
  font-weight: 600;
`
const ExpiryDateView = ({ id, expiryDate, disabled = false, handleOnChange, formError }) => {

  return (
    <div className="mb-3">
      <Form.Group className="mb-3">
        <Form.Label >{t('createLocalInventory:expiryDate')}</Form.Label><MediaQuery minWidth={550}><InformationPopover header={t('createLocalInventory:expiryDate')} content={t('createLocalInventory:expiryDateInfo')} /></MediaQuery>
        {!disabled ?
          <>
            <CustomDatePicker
              id={id}
              name="expiryDate"
              dateFormat="dd.MM.yyyy"
              placeholderText={t('date')}
              onChange={handleOnChange('expiryDate')}
              showYearDropdown
              selected={expiryDate}
              isInvalid={!!formError}
            />
            {!!formError &&
              <StyledValidationMessage>{formError}</StyledValidationMessage>
            }
          </>
          : formatedDate(expiryDate) ? <StyledBatchKey>{formatedDate(expiryDate)}</StyledBatchKey> : null
        }
      </Form.Group>
    </div>

  )
}
export default ExpiryDateView